export class SetNeedRefreshingMessageType {
    public static readonly type = '[Settings] Set needRefreshingMessageType';
    constructor(public needRefreshingMessageType: boolean) { }
  }
  